import { LorebookEntry, LorebookEntryFixStatus, LorebookEntryStatus, ModerationStatus } from "@next-platform/packages-ts-types";

/** True when the entry row should show a needs-fix / rejected highlight (not needs_review). */
export default function isEntryNeedsFix(entry: LorebookEntry): boolean {
  return (
    entry.status === LorebookEntryStatus.REJECTED ||
    entry.moderationReportStatus === ModerationStatus.FixRequired ||
    entry.fix_status === LorebookEntryFixStatus.NEEDS_FIX
  );
}
